import { HomeComponent } from './home.component';
import { AuthGuard } from '@/auth/guard/auth.guard';
import { getDefinitionByPath } from '@/auth/routes/auth.routes';
import { RouteWithGuardData } from '@/auth/interface/auth.interface';

export const homeChildRoutes: RouteWithGuardData[] = [
  {
    path: 'licenses',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: getDefinitionByPath('/search/driver'),
  },
  {
    path: 'infractions',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: getDefinitionByPath('/search/infraction'),
  },
  {
    path: 'requests',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: getDefinitionByPath('/search/requests'),
  },
];
